import evaHendriks from "../assets/profiles/eva-hendriks.jpg";
import sophieVanDijk from "../assets/profiles/sophie-van-dijk.jpg";

export const profilePhotos: Record<string, string> = {
  "eva-admin": evaHendriks,
  "sophie-admin": sophieVanDijk,
};
